"use client";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/identity-resolver/identity-resolver.ts
function identityResolver(value) {
	return value;
}
//#endregion
export { identityResolver };

//# sourceMappingURL=identity-resolver.mjs.map